<span
    class="table-data-field"
    [ngClass]="{
        'translucent-text': shouldAppearTransclusent
    }"
>
    {{ subElement }}
</span>
